import type { Background, Color } from '@genially/public-web-components';

import isNil from 'lodash/isNil';

export interface BackgroundDTO {
  backgroundType: 'image' | 'video' | 'solid';
  baseColor: {
    color: Color;
  };
  image?: {
    desktop?: ImageSource;
    laptop?: ImageSource;
    tablet?: ImageSource;
    mobile?: ImageSource;
  };
}

interface ImageSource {
  src: string;
}

export const parseBackground = (
  backgroundDTO: BackgroundDTO | undefined | null
): Background | undefined => {
  if (isNil(backgroundDTO)) return undefined;

  const background: Background = { color: backgroundDTO?.baseColor.color };
  if (!isNil(backgroundDTO.image)) {
    background.image = backgroundDTO?.image;
  }
  return background;
};
